import { render } from "./menu.vue?vue&type=template&id=34a797ae&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=34a797ae&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-34a797ae"

export default script